/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

function ensureYoutubeAPIReady() {
	return new Promise((resolve, reject) => {
		if (window.YT && window.YT.Player) {
			return resolve();
		}

        if (typeof window.onYouTubeIframeAPIReady !== 'undefined') {
            window.addEventListener("youtube-ready", resolve);
            return;
        }

		window.onYouTubeIframeAPIReady = () => {
            window.dispatchEvent(new Event("youtube-ready"));
			resolve();
		};

		let script = document.createElement("script");
		script.id = "youtube-iframe-script";
		script.src = "https://www.youtube.com/iframe_api";
		let firstScriptTag = document.getElementsByTagName("script")[0];
		firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	});
}

function ensureVimeoAPIReady() {
	return new Promise((resolve, reject) => {
		if (window.Vimeo && window.Vimeo.Player) {
			return resolve();
		}

		let script = document.createElement("script");
		script.id = "vimeo-iframe-script";
		script.src = "https://player.vimeo.com/api/player.js";

		script.onload = () => {
			if (window.Vimeo && window.Vimeo.Player) {
				resolve();
			} else {
				reject(
					new Error(
						"Vimeo API script loaded, but Vimeo or Vimeo.Player is still not available",
					),
				);
			}
		};

		script.onerror = () => {
			reject(new Error("Error loading Vimeo API script"));
		};

		let firstScriptTag = document.getElementsByTagName("script")[0];
		firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	});
}

const removePosterAndOverlay = (container) => {
    try {
        console.log('Attempting to remove poster and overlay');
        const poster = container.querySelector(".media-and-content-video__poster");
        const overlay = container.querySelector(".media-and-content-video__overlay");

        console.log('Found elements:', { poster, overlay });

        if (poster) {
            poster.style.opacity = 0;
            poster.style.visibility = "hidden";
            poster.style.pointerEvents = "none";
        }

        if (overlay) {
            overlay.style.opacity = 0;
            overlay.style.visibility = "hidden";
            overlay.style.pointerEvents = "none";
        }

        // Add is-playing class for CSS state management
        container.classList.add('is-playing');
    } catch (error) {
        console.error('Error in removePosterAndOverlay:', error);
    }
};

const hideElements = (container) => {
    const poster = container.querySelector(".media-and-content-video__poster");
    const overlay = container.querySelector(".media-and-content-video__overlay");
    
    if (poster) {
        poster.style.display = "none";
    }
    if (overlay) {
        overlay.style.display = "none";
    }
};

const enterKeyPressPlay = (video, play) => {
    try {
        console.log('Setting up enter key press handler');
        const playButton = video.querySelector(".media-and-content-video__overlay-icon");
        console.log('Found play button:', playButton);
        
        if (playButton) {
            playButton.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('Enter key pressed');
                    play();
                }
            });
        }
    } catch (error) {
        console.error('Error in enterKeyPressPlay:', error);
    }
};

const handleIframeVideos = () => {
    try {
        console.log('Starting handleIframeVideos');
        const videoCollection = document.getElementsByClassName(
            "media-and-content-video__stacking-grid",
        );

        if (!videoCollection || !videoCollection.length) {
            console.log('No video collection found');
            return;
        }

        console.log('Found video collection:', videoCollection);
        const videoArray = Array.from(videoCollection);

        videoArray.forEach((videoItem) => {
            console.log('Processing video item:', videoItem);
            console.log('Video controls setting:', videoItem.dataset.controls);

            if (videoItem.dataset.controls !== "true") {
                console.log('Controls disabled, hiding overlay elements');
                hideElements(videoItem);
                return;
            }

            if (videoItem.dataset.videoType === "video-youtube") {
                handleYouTubeVideo(videoItem);
            }
            
            if (videoItem.dataset.videoType === "video-vimeo") {
                handleVimeoVideo(videoItem);
            }
        });
    } catch (error) {
        console.error('Error in handleIframeVideos:', error);
    }
};

const handleYouTubeVideo = async (video) => {
    try {
        console.log('Setting up YouTube video');
        await ensureYoutubeAPIReady();
        
        const frame = video.getElementsByTagName("iframe")[0];
        if (!frame) {
            console.log('No iframe found for YouTube video');
            return;
        }

        frame.style.pointerEvents = "none";
        console.log('YouTube iframe found:', frame);

        const handlePlay = () => {
            console.log('YouTube play triggered');
            frame.style.visibility = "visible";
            frame.style.pointerEvents = "auto";
            
            const player = new YT.Player(frame, {
                events: {
                    onReady: (e) => {
                        console.log('YouTube player ready');
                        e.target.playVideo();
                        if (e.target.getPlayerState() != 5) {
                            removePosterAndOverlay(video);
                        }
                    },
                    onStateChange: (e) => {
                        console.log('YouTube player state changed:', e.target.getPlayerState());
                        if (e.target.getPlayerState() === 1) {
                            removePosterAndOverlay(video);
                        }
                        if (video.dataset.loop === "true" && e.target.getPlayerState() === 0) {
                            e.target.playVideo();
                        }
                    },
                },
            });
        };

        const setupClickHandler = (element) => {
            if (element) {
                element.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handlePlay();
                });
            }
        };

        if (video.dataset.controls === "true") {
            console.log('Setting up YouTube click handlers');
            const poster = video.querySelector(".media-and-content-video__poster");
            const overlay = video.querySelector(".media-and-content-video__overlay");
            const playButton = video.querySelector(".media-and-content-video__overlay-icon");

            setupClickHandler(poster);
            setupClickHandler(overlay);
            setupClickHandler(playButton);
            enterKeyPressPlay(video, handlePlay);
        }

        if (video.dataset.autoplay === "true") {
            console.log('Autoplay enabled, triggering play');
            handlePlay();
        }
    } catch (error) {
        console.error('Error in handleYouTubeVideo:', error);
    }
};

const handleVimeoVideo = async (video) => {
    try {
        console.log('Setting up Vimeo video');
        await ensureVimeoAPIReady();
        
        const frame = video.getElementsByTagName("iframe")[0];
        if (!frame) {
            console.log('No iframe found for Vimeo video');
            return;
        }

        console.log('Vimeo iframe found:', frame);
        const player = new Vimeo.Player(frame);
        
        const play = () => {
            console.log('Vimeo play triggered');
            player.play();
            removePosterAndOverlay(video);
        };

        const setupClickHandler = (element) => {
            if (element) {
                element.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    play();
                });
            }
        };

        if (video.dataset.controls === "true") {
            console.log('Setting up Vimeo click handlers');
            const poster = video.querySelector(".media-and-content-video__poster");
            const overlay = video.querySelector(".media-and-content-video__overlay");
            const playButton = video.querySelector(".media-and-content-video__overlay-icon");

            setupClickHandler(poster);
            setupClickHandler(overlay);
            setupClickHandler(playButton);
            enterKeyPressPlay(video, play);
        }

        if (video.dataset.autoplay === "true") {
            console.log('Autoplay enabled, triggering play');
            play();
        }

        player.on("play", () => {
            console.log('Vimeo video started playing');
            removePosterAndOverlay(video);
        });
    } catch (error) {
        console.error('Error in handleVimeoVideo:', error);
    }
};

const handleLocalVideos = () => {
    try {
        console.log('Starting handleLocalVideos');
        const blocks = document.querySelectorAll(
            ".wp-block-block-builder-by-arc-media-and-content"
        );
        
        console.log('Found blocks:', blocks);

        blocks.forEach((block) => {
            try {
                const video = block.querySelector(".media-and-content__local-video");
                const stackingGrid = block.querySelector(
                    ".media-and-content-video__stacking-grid"
                );

                console.log('Processing block:', {
                    hasVideo: !!video,
                    hasStackingGrid: !!stackingGrid,
                    controls: stackingGrid?.dataset.controls
                });

                if (!video || !stackingGrid) {
                    console.log('Missing video or stacking grid, skipping block');
                    return;
                }

                if (stackingGrid.dataset.controls !== "true") {
                    console.log('Controls disabled, hiding elements');
                    hideElements(stackingGrid);

                    if (stackingGrid.dataset.autoplay === "true") {
                        console.log('Autoplay enabled, playing video');
                        video.play().catch(err => console.error('Error playing video:', err));
                    }
                    return;
                }

                const handlePlay = (e) => {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    console.log('Local video play triggered');
                    try {
                        video.controls = true;
                        video.play().catch(err => console.error('Error playing video:', err));
                        removePosterAndOverlay(stackingGrid);
                    } catch (error) {
                        console.error('Error in play function:', error);
                    }
                };

                const setupClickHandler = (element) => {
                    if (element) {
                        element.addEventListener("click", handlePlay);
                    }
                };

                // Set up click handlers
                console.log('Setting up local video click handlers');
                const poster = stackingGrid.querySelector(".media-and-content-video__poster");
                const overlay = stackingGrid.querySelector(".media-and-content-video__overlay");
                const playButton = stackingGrid.querySelector(".media-and-content-video__overlay-icon");

                setupClickHandler(poster);
                setupClickHandler(overlay);
                setupClickHandler(playButton);

                if (playButton) {
                    playButton.addEventListener("keydown", (e) => {
                        if (e.key === "Enter") {
                            handlePlay(e);
                        }
                    });
                }

                video.addEventListener("playing", () => {
                    console.log('Video started playing');
                    removePosterAndOverlay(stackingGrid);
                });

            } catch (error) {
                console.error('Error processing individual block:', error);
            }
        });
    } catch (error) {
        console.error('Error in handleLocalVideos:', error);
    }
};

function initializeVideoHandlers() {
    console.log('Initializing video handlers');
    handleIframeVideos();
    handleLocalVideos();
}

if (document.readyState !== "loading") {
    console.log('Document ready, initializing video handlers');
    initializeVideoHandlers();
} else {
    console.log('Document loading, setting up DOMContentLoaded listeners');
    document.addEventListener("DOMContentLoaded", initializeVideoHandlers);
}

// Add GeoTargetWP event handler
jQuery(document).on("geotwp_ajax_success", function (event, response) {
    console.log('GeoTargetWP AJAX success, reinitializing video handlers');
    initializeVideoHandlers();
});